const CART_ADD = "/cart/add";
const CART_GET = "/cart";
const CART_UPDATE = "/cart/change";
const SITEWIDE_ONE_CLICK_PLAN_ID = 5356552419;

const cartDrawer = document.getElementById("CartDrawer");
const productDataCache = new Map();

// Intelligems A/B test: "Subscription by default". The variant adds the
// `subscription-default` class to <html>; add to cart (not buy now) then uses the
// product's first selling plan (form's data-default-selling-plan, rendered by
// the default-selling-plan-id snippet) instead of a one-time purchase.
function isSubscriptionDefaultVariant() {
  return document.documentElement.classList.contains("subscription-default");
}

function applyDefaultSellingPlan(form, formData) {
  if (!isSubscriptionDefaultVariant() || formData.get("selling_plan")) return;

  // /cart/add rejects anything that isn't a bare integer with a 400.
  const defaultSellingPlan = form.dataset.defaultSellingPlan?.trim();
  if (!defaultSellingPlan) return;

  if (/^\d+$/.test(defaultSellingPlan)) {
    formData.set("selling_plan", defaultSellingPlan);
  } else {
    console.warn("[SubscriptionDefault] Ignoring invalid data-default-selling-plan:", JSON.stringify(form.dataset.defaultSellingPlan));
  }
}

document.querySelectorAll('form[data-from="product-card"]').forEach(form => {
  form.addEventListener('submit', handleAddToCart);
});

const headerCartButton = document.querySelector(".cart-drawer-button");
if (headerCartButton) {
  headerCartButton.addEventListener("click", async () => {
    try {
      const cart = await handleCartAction(CART_GET, "GET");
      handleUpdateCartCount(cart);
      await reloadCart(cart.items, cart.total_price);
      updateGiftSection(cart.total_price);
    } catch (error) {
      console.error("Cart Operation Failed:", error);
    }
  });
}

document.body.addEventListener("click", e => {
  if (e.target.matches('.drawer-cart-item__one-time-purchase')) {
    const parent = e.target.closest(".drawer-cart-item__selector-container");
    const nativeSelect = parent.querySelector('.custom-select-wrapper');
    handleUpdateCart(e.target, nativeSelect);
  } else if (e.target.matches('.drawer-cart-item__select-button')) {
    const parent = e.target.closest(".custom-select-wrapper");
    const selectOptions = parent.querySelector('.drawer-cart-item__select-options');
    const arrow = parent.querySelector('.drawer-cart-item__arrow');

    e.stopPropagation();
    selectOptions.classList.toggle('open');
    arrow.classList.toggle('open');
  } else if (e.target.matches('.drawer-cart-item__select-option')) {
    const parent = e.target.closest(".custom-select-wrapper");
    const selectedValue = parent.querySelector('.drawer-cart-item__selected-value');
    const nativeSelect = parent.querySelector('.drawer-cart-item__subscription-selector');
    const selectOptions = parent.querySelector('.drawer-cart-item__select-options');
    const options = parent.querySelectorAll('.drawer-cart-item__select-option');
    const arrow = parent.querySelector('.drawer-cart-item__arrow');

    const value = e.target.getAttribute('data-value');

    selectedValue.textContent = e.target.innerText;

    nativeSelect.value = value;

    options.forEach(opt => opt.classList.remove('selected'));
    e.target.classList.add('selected');

    selectOptions.classList.remove('open');
    arrow.classList.remove('open');

    handleButtonLoading(parent);

    handleUpdateCart(nativeSelect, nativeSelect.closest("[data-quantity-selector]") || nativeSelect );
  } else {
    const selectOptions = document.querySelector('.drawer-cart-item__select-options.open');
    const arrow = document.querySelector('.custom-select-wrapper:has(.drawer-cart-item__select-options.open) .drawer-cart-item__arrow');
    if (selectOptions && selectOptions.classList.contains('open')) {
      selectOptions.classList.remove('open');
      arrow.classList.remove('open');
    }
  }
})

document.body.addEventListener('change', e => {
  if (e.target.matches('[data-cart-subscription-switch]')) {
    if (e.target.checked) {
      const parent = e.target.closest(".drawer-cart-item__subscription-switch");
      const currentSellingPlan = parent.querySelector(".drawer-cart-item__subscription-selector");
      e.target.dataset.sellingPlan = currentSellingPlan.value;
    } else {
      e.target.dataset.sellingPlan = "";
    }
    handleUpdateCart(e.target, e.target.closest("[data-quantity-selector]") || e.target );
  }
});

document.body.addEventListener('click', e => {
  const buyNowButton = e.target.closest('[data-action="buy-now"]');
  if (buyNowButton) {
    handleBuyNow(e, buyNowButton);
  }
  else if (e.target.matches('[data-type="minus"][data-is-from-cart]') || e.target.matches('[data-type="plus"][data-is-from-cart]') || e.target.matches('[data-type="remove"][data-is-from-cart]')) {
    handleUpdateCart(e.target, e.target.closest("[data-quantity-selector]") || e.target );
  } 
  else if (e.target.matches('button[name="minus"]') || e.target.matches('button[name="plus"]')) {
    handleUpdateQuantitySelector(e.target);
  } else if (e.target.matches(".cart-recommended-item__add")) {
    addRecommendationToCart(e.target);
  } else if (e.target.matches('[data-to-one-time-purchase]')) {
    handleUpdateCart(e.target, e.target.closest("[data-quantity-selector]") || e.target )
  } else if (e.target.matches('#shop-now-side-cart')) {
    if (window.location.pathname != '/collections/bestsellers') {
      window.location.href = "/collections/bestsellers";
    }
  }
});

function handleUpdateQuantitySelector(button) {
  const quantitySelector = button.closest('[data-quantity-selector]');
  const input = quantitySelector.querySelector('input[name="quantity"]');
  const currentValue = parseInt(input.value) || 0;
  const min = parseInt(input.min) || 1;
  
  input.value = button.name === 'minus' 
    ? Math.max(min, currentValue - 1) 
    : Math.min(10, currentValue + 1);
  
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

function handleButtonLoading(btn, loading) {
  btn?.classList.toggle("btn--loading", loading);
}

function isButtonLoading(btn) {
  return Boolean(btn?.classList.contains("btn--loading"));
}

// Buy Now leaves the page while still loading; clear loaders when the browser restores it from the back/forward cache
window.addEventListener("pageshow", e => {
  if (!e.persisted) return;
  document.querySelectorAll(".btn--loading").forEach(el => el.classList.remove("btn--loading"));
});

async function handleUpdateCartCount(cartInfo) {
  cartInfo ??= await handleCartAction(CART_GET, "GET");

  const quantityCounters = document.querySelectorAll("cart-count");
  quantityCounters.forEach(counter => {
    counter.innerText = cartInfo.item_count;
  })
}

const CART_CONFIG = {
  ENABLE_BONUS_TRIGGERS: false, 
  ENABLE_PRODUCT_LIMITS: false, 
  ENABLE_AUTO_DISCOUNT: true,
  BONUS_TRIGGERS: {
    "47232180322531": "45624141578467"
  },
  PRODUCT_LIMITS: {
    "45624141578467": 1,
  },
  PRODUCT_DISCOUNTS: {
    "49568398115043": "BLACK-SEED-BUY-1-GET-1-FREE-BSO",
    "49510423888099": "COCOA-BUY-1-GET-1-FREE-BSO",
    "49510425952483": "NMN-BUY-1-GET-1-FREE-BSO",
    "49510430703843": "TURK-&-TONGKAT-BUY-1-GET-1-FREE-BSO",
    "49510426542307": "NATTOKINASE-BUY-1-GET-1-FREE-BSO",
    "49510446760163": "CREATINE-BUY-1-GET-1-FREE-BSO",
    "49510444859619": "SPIKE-BUY-1-GET-1-FREE-BSO",
    "49510440239331": "SLEEPY-COCOA-BUY-1-GET-1-FREE-BSO",
    "49510435291363": "LONGEVITY-BUY-1-GET-1-FREE-BSO",
    "49510448431331": "SPERMIDINE-BUY-1-GET-1-FREE-BSO",
    "49510450954467": "GLP-1-BUY-1-GET-1-FREE-BSO",
    "49510451118307": "SLEEP-AID-BUY-1-GET-1-FREE-BSO",
    "49510460817635": "CISTANCHE-BUY-1-GET-1-FREE-BSO",
    "49510464454883": "TURKESTERONE-BUY-1-GET-1-FREE-BSO",
    "49510458392803": "BERBERINE-BUY-1-GET-1-FREE-BSO",
    "49510458196195": "BRAIN-COMPLEX-BUY-1-GET-1-FREE-BSO",
    "67978255466723": "PROTEIN-COFFEE-BUY-1-GET-1-FREE-BSO",
  },
};

async function handleAddToCart(e) {
  e.preventDefault();

  const form = e.target;
  const addToCartButton = e.submitter || form.querySelector("button[type=submit]");
  if (isButtonLoading(addToCartButton)) return;
  handleButtonLoading(addToCartButton, true);

  const formData = new FormData(form);
  const cardQtyInput = form.closest('.categories-bento__card')?.querySelector('[data-quantity-selector] input[name="quantity"]');
  if (cardQtyInput) formData.set('quantity', cardQtyInput.value);
  processSubscriptionFields(form, formData);
  applyDefaultSellingPlan(form, formData);

  try {
    const currentCart = CART_CONFIG.ENABLE_PRODUCT_LIMITS
      ? await handleCartAction(CART_GET, "GET")
      : null;
    await manageProductGovernance(formData, currentCart);
    const mainProductId = formData.get("id");

    if (CART_CONFIG.ENABLE_BONUS_TRIGGERS && CART_CONFIG.BONUS_TRIGGERS[mainProductId]) {
      const bonusId = CART_CONFIG.BONUS_TRIGGERS[mainProductId];
      const bonusFormData = new FormData();
      bonusFormData.append("id", bonusId);
      bonusFormData.append("quantity", "1");

      await manageProductGovernance(bonusFormData, currentCart);
    }

    let updatedCart = await handleCartAction(CART_GET, "GET");
    let discountChanged = await syncTierDiscount(updatedCart);

    // Applied after the tier sync, which sets the cart's codes
    if (CART_CONFIG.ENABLE_AUTO_DISCOUNT && CART_CONFIG.PRODUCT_DISCOUNTS[mainProductId]) {
      const discountCode = CART_CONFIG.PRODUCT_DISCOUNTS[mainProductId];
      await applyDiscountCodeInBackground(discountCode);
      discountChanged = true;
    }

    if (discountChanged) {
      updatedCart = await handleCartAction(CART_GET, "GET");
    }

    handleUpdateCartCount(updatedCart);

    await reloadCart(updatedCart.items, updatedCart.total_price);
    updateGiftSection(updatedCart.total_price);

    cartDrawer.classList.add("active");
  } catch (error) {
    console.error("Cart Operation Failed:", error);
  } finally {
    handleButtonLoading(addToCartButton, false);
  }
}

async function manageProductGovernance(formData, currentCart) {
  if (!CART_CONFIG.ENABLE_PRODUCT_LIMITS) {
    await handleCartAction(CART_ADD, "POST", formData);
    return; 
  }

  const productId = formData.get("id");
  let requestedQty = parseInt(formData.get("quantity") || 1);
  const limit = CART_CONFIG.PRODUCT_LIMITS[productId];

  if (limit === undefined) {
    await handleCartAction(CART_ADD, "POST", formData);
    return;
  }

  const lineItem = currentCart.items.find(item => item.id == productId);
  const currentQty = lineItem ? lineItem.quantity : 0;

  if (currentQty > limit) {
    console.warn(`[Correction] Product ${productId} is over limit (${currentQty}/${limit}). Correcting...`);
    await updateCartQuantity(productId, limit); 
    return; 
  }

  if (currentQty === limit) {
    return;
  }

  const remainingAllowance = limit - currentQty;
  const safeToAdd = Math.min(requestedQty, remainingAllowance);

  if (safeToAdd > 0) {
    if (safeToAdd !== requestedQty) {
    }
    
    formData.set("quantity", safeToAdd);
    await handleCartAction(CART_ADD, "POST", formData);
  }
}

async function updateCartQuantity(id, quantity) {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("quantity", quantity);

  try {
    await handleCartAction("CART_UPDATE", "POST", formData);
  } catch (e) {
    console.error("Could not correct cart quantity", e);
  }
}

function processSubscriptionFields(form, formData) {
  if (form.dataset.subscription === "true") {
    formData.append("selling_plan", getSellingPlan(form));
  } 
  else if (formData.get('selling_plan') == '') {
    formData.delete("selling_plan");
  }
}

async function applyDiscountCodeInBackground(code) {
  try {
    await fetch(`/discount/${code}`);
  } catch (error) {
    console.error("Failed to apply discount code:", error);
  }
}

// -----------------------------
// TIER PROMOS
// A tier purchase replaces whatever the cart holds for that variant. Each tier line carries the
// product's tier codes, and the cart applies the best one for the bottles in the cart and the line's
// purchase type (6+ bottles: 6-bottle code, 3-5: 3-bottle code), the same price the PDP shows for
// that tier; each code's minimum quantity is enforced by Shopify at checkout. Tier data travels on
// hidden line item properties, set by the product section that sold the tier (new-ps-main-product, with
// codes and Loop plans from custom-tier-ab-config).
// Codes are set with the cart API, which replaces the cart's codes: /discount/CODE only adds one, so codes
// from earlier tiers or products piled up and kept the right one from applying.
// -----------------------------
// Tier codes are PRODUCT-T3-XXXX / PRODUCT-S6-XXXX (custom-tier-ab-config); "CLEAR" is left from an older
// way of removing them
function isTierCode(code) {
  return /-[TS][36]-/.test(code) || code === "CLEAR";
}

// Sets the cart's discount codes to exactly these; one retry, for flaky connections
async function setCartDiscountCodes(codes) {
  const body = JSON.stringify({ discount: codes.join(",") });
  try {
    return await handleCartAction("/cart/update.js", "POST", body, { 'Content-Type': 'application/json' });
  } catch (error) {
    await new Promise(resolve => setTimeout(resolve, 800));
    return handleCartAction("/cart/update.js", "POST", body, { 'Content-Type': 'application/json' });
  }
}

// "3:CODE,6:CODE" -> [[3, "CODE"], [6, "CODE"]] (line item properties are strings)
function parseTierCodes(value) {
  return (value || "")
    .split(",")
    .map(entry => entry.split(":"))
    .filter(([quantity, code]) => quantity && code)
    .map(([quantity, code]) => [parseInt(quantity, 10), code]);
}

// The biggest tier the bottles in the cart reach, for how the line is bought
function getTierCode(item, units) {
  const properties = item.properties || {};
  const codes = parseTierCodes(item.selling_plan_allocation
    ? properties._tier_codes_subscription
    : properties._tier_codes_one_time);
  const best = codes
    .filter(([quantity]) => units >= quantity)
    .sort((a, b) => b[0] - a[0])[0];

  return best ? best[1] : "";
}

// Every tier plan id, rendered by the cart drawer (custom-tier-ab-config)
function getTierPlanIds() {
  try {
    return JSON.parse(document.getElementById("TierAbPlanIds")?.textContent || "[]").map(String);
  } catch (e) {
    return [];
  }
}

// Tier lines offer only their tier's Loop plans; every other line only the regular ones
function getDrawerSellingPlans(product, item) {
  if (!product.selling_plan_groups || product.selling_plan_groups.length === 0) return [];

  const plans = product.selling_plan_groups[0].selling_plans
    .filter(sellingPlan => sellingPlan.id != SITEWIDE_ONE_CLICK_PLAN_ID);
  const tierPlans = item.properties?._tier_plans?.split(",") || [];

  if (tierPlans.length > 0) {
    return plans.filter(sellingPlan => tierPlans.includes(String(sellingPlan.id)));
  }

  const tierPlanIds = getTierPlanIds();
  return plans.filter(sellingPlan => !tierPlanIds.includes(String(sellingPlan.id)));
}

// The cart gets the best tier code for its tier lines, alone (a tier purchase carries its own discount);
// without tier lines, tier codes go and any other code stays. Returns true when the cart's codes changed, so
// callers can refetch the cart. A failure only logs: the next page load tries again (see below).
async function syncTierDiscount(cart) {
  const unitsOf = item => cart.items
    .filter(line => line.id === item.id)
    .reduce((sum, line) => sum + line.quantity, 0);
  const eligibleLine = cart.items.find(item => getTierCode(item, unitsOf(item)));
  const current = (cart.discount_codes || []).map(discount => discount.code);
  const wanted = eligibleLine
    ? [getTierCode(eligibleLine, unitsOf(eligibleLine))]
    : current.filter(code => !isTierCode(code));

  if (wanted.length === current.length && wanted.every(code => current.includes(code))) return false;

  try {
    await setCartDiscountCodes(wanted);
    return true;
  } catch (error) {
    console.error("[Tiers] Could not set the tier discount code:", error);
    return false;
  }
}

// A tier code can be missing (a request failed) or left over (the cart changed elsewhere): every page checks it
(async () => {
  try {
    const cart = await handleCartAction(CART_GET, "GET");
    if (cart.item_count > 0 || cart.discount_codes?.length > 0) await syncTierDiscount(cart);
  } catch (error) {}
})();

async function handleBuyNow(e, button) {
  e.preventDefault();

  button = button || e.target;
  const form = button.closest('form');

  if (isButtonLoading(button)) return;
  handleButtonLoading(button, true);

  const formData = new FormData(form);
  const cardQtyInput = form.closest('.categories-bento__card')?.querySelector('[data-quantity-selector] input[name="quantity"]');
  if (cardQtyInput) formData.set('quantity', cardQtyInput.value);
  const sellingPlan = button.dataset.subscription === "true"
    ? getSellingPlan(form)
    : formData.get('selling_plan');

  if (sellingPlan && sellingPlan !== '') {
    formData.set('selling_plan', sellingPlan);
  } else {
    formData.delete('selling_plan');
  }

  try {
    const currentCart = CART_CONFIG.ENABLE_PRODUCT_LIMITS
      ? await handleCartAction(CART_GET, "GET")
      : null;
    await manageProductGovernance(formData, currentCart);
    const mainProductId = formData.get("id");

    if (CART_CONFIG.ENABLE_BONUS_TRIGGERS && CART_CONFIG.BONUS_TRIGGERS[mainProductId]) {
       const bonusId = CART_CONFIG.BONUS_TRIGGERS[mainProductId];
       const bonusFormData = new FormData();
       bonusFormData.append("id", bonusId);
       bonusFormData.append("quantity", "1");

       await manageProductGovernance(bonusFormData, currentCart);
    }

    await syncTierDiscount(await handleCartAction(CART_GET, "GET"));

    // UPDATED FIX: Apply discount in the background just like Add to Cart
    if (CART_CONFIG.ENABLE_AUTO_DISCOUNT && CART_CONFIG.PRODUCT_DISCOUNTS[mainProductId]) {
      const discountCode = CART_CONFIG.PRODUCT_DISCOUNTS[mainProductId];
      await applyDiscountCodeInBackground(discountCode);
    }

    // Redirect to clean checkout URL. The background fetch already applied the code.
    window.location.href = '/checkout';

  } catch (error) {
    console.error("Buy Now Operation Failed:", error);
    handleButtonLoading(button, false);
  }
}

async function handleCartAction(url, method, body, headers) {
  try {
    const res = await fetch(url, {
      method: method,
      headers: {
        'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest', ...headers
      },
      ...(body && { body })
    })

    return await res.json();
  } catch (error) {
    console.error('Cart action failed:', error);
    throw error;
  }
}

function getSellingPlan(form) {
  const sellingPlan = form.querySelector(".custom-subscriptions-widget__select") ? form.querySelector(".custom-subscriptions-widget__select").value : form.querySelector(".loop-selling-plan-selector").value;

  return sellingPlan;
}

async function handleUpdateCart(btn, toLoad) {
  let quantity;
  // Tier lines step by whole tiers (3 -> 6 -> 9) so the tier promo keeps applying
  const step = parseInt(btn.dataset.tierStep, 10) || 1;

  switch (btn.dataset.type) {
    case "minus":
      quantity = +btn.dataset.quantity - step;
      break;
    case "plus":
      quantity = +btn.dataset.quantity + step;
      break;
    default:
      quantity = +btn.dataset.quantity;
      break;
  }

  let sellingPlan = btn.dataset.sellingPlan;

  if (btn.dataset.isSubsSelect == "") {
    sellingPlan = btn.value;
  }

  const body = JSON.stringify({
    quantity,
    selling_plan: sellingPlan,
    line: btn.dataset.index
  })

  try {
    handleButtonLoading(toLoad);
    let res = await handleCartAction(CART_UPDATE, "POST", body, { 'Content-Type': 'application/json' });
    if (await syncTierDiscount(res)) {
      res = await handleCartAction(CART_GET, "GET");
    }

    await reloadCart(res.items, res.total_price);
    handleUpdateCartCount(res);
    handleButtonLoading(toLoad);
    updateGiftSection(res.total_price);
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

async function reloadCart(items, total_price) {
  const consolidatedItems = {};
  items.forEach((item, index) => {
    const productId = item.product_id;

    if (!consolidatedItems[productId]) {
      consolidatedItems[productId] = {
        firstItem: item,
        total_quantity: 0,
        total_final_line_price: 0,
        total_original_line_price: 0,
        total_regular_line_price: 0,
        original_index: index + 1,
        first_occurrence_quantity: item.quantity,
        product_id: productId,
        handle: item.handle,
        url: item.url,
        image: item.image,
        discount_title: null
      };
    }

    if (item.discounts.length > 0 && !consolidatedItems[productId].discount_title) {
        consolidatedItems[productId].discount_title = item.discounts[0].title;
    }

    consolidatedItems[productId].total_quantity += item.quantity;
    consolidatedItems[productId].total_final_line_price += item.final_line_price;
    consolidatedItems[productId].total_original_line_price += item.original_line_price;
    // Before plan and code discounts (a subscription's original price already has the plan applied)
    consolidatedItems[productId].total_regular_line_price +=
      (item.selling_plan_allocation?.compare_at_price ?? item.original_price) * item.quantity;
  });

  const consolidatedItemsArray = Object.values(consolidatedItems);

  const cartItemTemplate = document.querySelector(".drawer-cart-item--hidden");
  const cartBody = document.querySelector(".custom-cart-drawer__items-list");
  const cartSavingsContainer = document.querySelector(".custom-cart-drawer__saving-message");
  const cartSavings = document.querySelector(".custom-cart-drawer__saving-message span");
  const cartTotal = document.querySelector(".custom-cart-drawer__subtotal-money");
  const cartEmpty = document.querySelector(".custom-cart-drawer__empty");
  const cartFooter = document.querySelector(".custom-cart-drawer__footer");
  const fragment = new DocumentFragment();
  // Real savings: regular prices minus what the cart actually costs (plan and code discounts included)
  const regularTotal = items.reduce((sum, item) => {
    const regularPrice = item.selling_plan_allocation?.compare_at_price ?? item.original_price;
    return sum + regularPrice * item.quantity;
  }, 0);

  const itemElements = await Promise.all(consolidatedItemsArray.map(async (consolidated) => {
    const item = consolidated.firstItem;

    let cached = productDataCache.get(item.handle);
    if (!cached) {
      const query = `
        query getProduct($handle: String!) {
          product(handle: $handle) {
            metafields(identifiers: [
              {namespace: "custom", key: "title_mobile"}
            ]) {
              value
            }
            compareAtPriceRange {
              maxVariantPrice { amount currencyCode }
              minVariantPrice { amount currencyCode }
            }
          }
        }`;
      const variables = { handle: item.handle };

      const [graphqlResult, product] = await Promise.all([
        fetch('/api/2023-10/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': "0d8cd5cd2a42d65749a264ea5a35554c"
          },
          body: JSON.stringify({ query, variables })
        }).then(response => response.json()),
        fetch(`/products/${item.handle}.js`).then(response => response.json())
      ]);

      cached = { data: graphqlResult.data, product };
      productDataCache.set(item.handle, cached);
    }
    const { data, product } = cached;


    const newCartItem = cartItemTemplate.cloneNode(true);
    newCartItem.classList.remove("drawer-cart-item--hidden");

    const setDataElements = newCartItem.querySelectorAll('[data-variant-id=""]');
    const anchors = newCartItem.querySelectorAll('a');
    const image = newCartItem.querySelector("img");
    const compareAtPrice = newCartItem.querySelector(".cart-item__price--regular");
    const salePrice = newCartItem.querySelector(".cart-item__price--sale");
    const quantityInput = newCartItem.querySelector(".drawer-cart-quantity-selector__input");

    newCartItem.dataset.variantId = item.id;
    newCartItem.dataset.index = consolidated.original_index;
    newCartItem.dataset.quantity = consolidated.first_occurrence_quantity;
    
    const select = newCartItem.querySelector(".drawer-cart-item__subscription-selector");
    const customSelect = newCartItem.querySelector(".drawer-cart-item__select-options");
    const oneTimeCustomOption = customSelect.querySelector(".drawer-cart-item__select-option");
    const selectedValue = newCartItem.querySelector(".drawer-cart-item__selected-value");
    const subscriptionSwitch = newCartItem.querySelector("[data-cart-subscription-switch]");
    const subscriptionName = newCartItem.querySelector(".switch-container > p");

    const sellableSellingPlans = getDrawerSellingPlans(product, item);

    if (sellableSellingPlans.length > 0) {

      let subsName = "";

      if (sellableSellingPlans[0].price_adjustments[0].value === 0) {
        subsName = product.selling_plan_groups[0].name;
      } else {
        subsName = product.selling_plan_groups[0].name + " " + sellableSellingPlans[0].price_adjustments[0].value + "%";
      }
      subscriptionName.textContent = subsName;

      sellableSellingPlans.forEach(sellingPlan => {
        const option = document.createElement('option');
        const customOption = oneTimeCustomOption.cloneNode(true);
        option.value = sellingPlan.id;
        option.textContent = sellingPlan.name;
        customOption.dataset.value = sellingPlan.id;
        customOption.querySelector(".name").textContent = sellingPlan.name;
        if ((item.selling_plan_allocation != null) && item.selling_plan_allocation.selling_plan.id == sellingPlan.id) {
          option.setAttribute("selected", true);
          customOption.classList.add("selected");
          selectedValue.textContent = sellingPlan.name;
        }
        select.add(option);
        customSelect.appendChild(customOption);
      })
      const oneTimeOption = select.querySelector("option:first-child");
      oneTimeOption.remove();
      oneTimeCustomOption.remove();
      if (item.selling_plan_allocation != null) {
        subscriptionSwitch.checked = true;
        subscriptionSwitch.dataset.sellingPlan = item.selling_plan_allocation.selling_plan.id;
      } else {
        newCartItem.querySelector(".drawer-cart-item__selector-container").classList.add("hidden");
      }
    } else {
      newCartItem.querySelector(".drawer-cart-item__subscription-switch").classList.add("hidden");
    }

    const discountContainer = newCartItem.querySelector(".drawer-cart-item__discount");
    const notApplicableMessage = newCartItem.querySelector(".drawer-cart-item__not-applicable");

    if (consolidated.discount_title) {
      discountContainer.querySelector('span').textContent = consolidated.discount_title;
    } else {
      discountContainer.remove();
      notApplicableMessage.remove();
    }

    setDataElements.forEach((dataElement) => {
      dataElement.dataset.variantId = item.id;
      dataElement.dataset.index = consolidated.original_index;
      if (dataElement.dataset.quantity != "0") dataElement.dataset.quantity = consolidated.first_occurrence_quantity;
      if (dataElement.hasAttribute('aria-label')) {
        dataElement.setAttribute("aria-label", dataElement.getAttribute("aria-label") + item.title);
      }
    });

    const tierStep = item.properties?._tier_quantity;
    if (tierStep) {
      newCartItem.querySelectorAll('[data-type="minus"], [data-type="plus"]').forEach(control => {
        control.dataset.tierStep = tierStep;
      });
      quantityInput.readOnly = true;
    }

    anchors.forEach(anchor => {
      anchor.href = item.url;
      if(data.product.metafields && data.product.metafields.length > 0) {
        anchor.innerText = data.product.metafields[0].value;
      } else {
        anchor.innerText = item.product_title;
      }
    });
    
    image.src = item.image;
    image.alt = "Photo of " + item.title;
    // Real discount (plan or code): strike the regular price; otherwise the compare-at price
    const hasRealDiscount = consolidated.total_final_line_price < consolidated.total_regular_line_price;
    compareAtPrice.innerText = hasRealDiscount
      ? "$" + formatNumber(consolidated.total_regular_line_price / 100)
      : "$" + formatNumber((data.product.compareAtPriceRange.minVariantPrice.amount * consolidated.total_quantity));
    salePrice.innerText = "$" + formatNumber((consolidated.total_final_line_price / 100));
    quantityInput.value = consolidated.total_quantity;
    quantityInput.size = String(consolidated.total_quantity).length;

    if (!hasRealDiscount && data.product.compareAtPriceRange.minVariantPrice.amount < 1) {
      compareAtPrice.remove();
    }
    
    return newCartItem;
  }));

  itemElements.forEach(itemElement => fragment.appendChild(itemElement));

  cartBody.innerHTML = "";
  cartBody.appendChild(fragment);
  // With a promo (plan or code) show only the real savings; otherwise savings against compare-at
  const realSavings = regularTotal - total_price;
  const totalSavings = realSavings > 0 ? realSavings : items.reduce((sum, item) => {
    const variant = productDataCache.get(item.handle)?.product.variants.find(v => v.id === item.variant_id);
    const compareAtLine = (variant?.compare_at_price ?? 0) * item.quantity;
    return sum + Math.max(0, compareAtLine - item.final_line_price);
  }, 0);
  cartSavings.innerText = `$${formatNumber(totalSavings / 100)}`;
  cartTotal.innerText = `$${formatNumber((total_price / 100))} USD`;

  if (items.length == 0) {
    cartSavingsContainer.classList.add("hidden");
    cartEmpty.classList.remove("hidden");
    cartFooter.classList.add("hidden");
  } else {
    cartSavingsContainer.classList.toggle("hidden", totalSavings <= 0);
    cartEmpty.classList.add("hidden");
    cartFooter.classList.remove("hidden");
  }
  
  const hostElement = document.querySelector('.custom-cart-drawer square-placement');
  if (hostElement && hostElement.shadowRoot) {
    const mainText = hostElement.shadowRoot.querySelector('.afterpay-main-text strong');
    if (mainText) {
      mainText.innerText = `$${((total_price / 100) / 4).toFixed(2)}`;
    }
  }
}

async function setRecommended(productId) {
  const recommendedContainer = document.querySelector(".custom-cart-drawer__recommended-list");
  const recommendedTemplate = document.querySelector(".cart-recommended-item--hidden");
  const fragment = new DocumentFragment();

  await fetch(`/recommendations/products.json?product_id=${productId}&limit=10&intent=complementary`)
  .then(res => res.json())
  .then(res => {
    res.products.forEach(product => {
      const newRecommendedItem = recommendedTemplate.content.cloneNode(true);

      const itemWrapper = newRecommendedItem.querySelector('.cart-recommended-item');
      const image = newRecommendedItem.querySelector("img");
      const title = newRecommendedItem.querySelector(".cart-recommended-item__title");
      const compareAtPrice = newRecommendedItem.querySelector(".cart-recommended-item__price--regular");
      const price = newRecommendedItem.querySelector(".cart-recommended-item__price--sale");
      const addButton = newRecommendedItem.querySelector(".cart-recommended-item__add");

      itemWrapper.classList.remove('cart-recommended-item--hidden');

      image.src = product.featured_image;
      image.alt = product.title;
      title.textContent = product.title;

      if (product.compare_at_price) {
        compareAtPrice.textContent = `$${product.compare_at_price/ 100}`;
      } else {
        compareAtPrice.remove();
      }
      
      price.textContent = `$${item.final_price / 100}`;

      if (product.variants.length > 0) {
        addButton.dataset.variantId = product.variants[0].id;
      } else {
        addButton.remove();
      }

      fragment.appendChild(newRecommendedItem);
    });

    const recommendedTitle = recommendedContainer.firstElementChild.cloneNode(true);
    recommendedContainer.innerHTML = '';
    recommendedContainer.appendChild(recommendedTitle);
    recommendedContainer.appendChild(fragment);
  })
  .catch(error => {
    console.error('Error fetching product recommendations:', error);
  });
}

async function addRecommendationToCart(btn) {
  try {
    const formData = new FormData();
    formData.append("id", btn.dataset.variantId);
    formData.append("quantity", btn.dataset.quantity);
    
    await handleCartAction(CART_ADD, "POST", formData);

    let res = await handleCartAction(CART_GET, "GET");
    if (await syncTierDiscount(res)) {
      res = await handleCartAction(CART_GET, "GET");
    }
    handleUpdateCartCount(res);

    reloadCart(res.items, res.total_price)
  } catch (error) {
    console.error('Error adding product recommended to cart:', error);
  }
}

function updateGiftSection(cartTotalCents) {
  const giftThreshold = 20000;
  
  const progressPercentage = Math.min(Math.max((cartTotalCents / giftThreshold) * 100, 0), 100);

  const progressFill = document.querySelector('.progress-fill');
  if (progressFill) {
    progressFill.style.width = `${progressPercentage}%`;
  }

  const giftMessage = document.querySelector('.gift-message');
  if (giftMessage) {
    if (cartTotalCents >= giftThreshold) {
      giftMessage.innerHTML = '<p class="success">🎉 You received a free gift!</p>';
    } else {
      const remaining = (giftThreshold - cartTotalCents) / 100;
      giftMessage.innerHTML = `<p>Spend $${remaining.toFixed(2)} more to unlock a free gift!</p>`;
    }
  }
}

async function convertAllToSubscription(btn) {
  if (btn.checked == true) {
    updateAllSellingPlans(btn.dataset.sellingPlan, btn.closest('.custom-cart-drawer__subs'), btn);
  } else {
    updateAllSellingPlans('', btn.closest('.custom-cart-drawer__subs'), btn);
  }
}

async function updateAllSellingPlans(sellingPlanId, toLoad, btn) {
  try {
    handleButtonLoading(toLoad);
    const cart = await handleCartAction(CART_GET, "GET");

    const results = [];

    for (const item of cart.items) {
      try {
        if (item.selling_plan_allocation?.selling_plan?.id === sellingPlanId) {
          results.push({ success: true, skipped: true, item: item.key });
          continue;
        }

        const body = JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          selling_plan: sellingPlanId
        });

        await handleCartAction('/cart/change.js', "POST", body, { 
          'Content-Type': 'application/json' 
        });
        
        results.push({ success: true, item: item.key });
      } catch (error) {
        results.push({ 
          success: false, 
          item: item.key,
          error: error.message || 'Item update failed'
        });
      }
    }

    let res = await handleCartAction(CART_GET, "GET");
    if (await syncTierDiscount(res)) {
      res = await handleCartAction(CART_GET, "GET");
    }
    reloadCart(res.items, res.total_price);
    handleButtonLoading(toLoad);

    return {
      success: results.every(r => r.success),
      updated: results.filter(r => r.success && !r.skipped).length,
      skipped: results.filter(r => r.skipped).length,
      failed: results.filter(r => !r.success).length,
      results
    };
    
  } catch (error) {
    return {
      success: false,
      error: error.message || 'Failed to process cart'
    };
  }
}

function updateSubscriptionMessage(btn, items) {
  const messageTag = document.querySelector(".custom-cart-drawer__subs > p");
  
  if (btn.checked) {
    let totalSaved = 0;
    items.forEach(item => {
      totalSaved += item.final_price;
    });

    totalSaved *= 0.2;
    totalSaved /= 100;

    messageTag.innerText = `YOU'RE SAVING $${totalSaved.toFixed(2)} AS A SUBSCRIBER`;
  } else {
    let totalSaved = 0;
    items.forEach(item => {
      if (!item.selling_plan_allocation) {
        totalSaved += item.final_price;
      }
    });

    totalSaved *= 0.2;
    totalSaved /= 100;

    messageTag.innerText = `AUTOSHIP & SAVE AN EXTRA $${totalSaved.toFixed(2)}!`;
  }
}

function formatNumber(num) {
  const numericValue = parseFloat(num);

  if (isNaN(numericValue)) {
    return "Invalid Number";
  }

  const options = {
    useGrouping: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  return numericValue.toLocaleString('es-US', options);
}